"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Layout = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Layout"));
var _CornerstoneButton = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneButton"));
var _utils = require("cornerstone_ui_core/lib/utils");
var _Menu = _interopRequireDefault(require("../Menu"));
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // import { constructImageUrl } from "../base-layout.constants";
const {
  Sider
} = _Layout.default;
class _default extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "sideNavToggle", e => {
      e.preventDefault();
      this.props.sideNavToggle();
    });
    _defineProperty(this, "sideNavHide", e => {
      e.preventDefault();
      this.props.sideNavHide();
    });
    _defineProperty(this, "sideNavShow", e => {
      e.preventDefault();
      this.props.sideNavShow();
    });
    _defineProperty(this, "onAvatarError", e => {
      this.setState({
        imageSrc: ""
      });
    });
    this.state = {
      imageSrc: ""
    };
    this.props.sideNavHide();
  }
  componentDidMount() {
    let appName = (0, _utils.getAppName)();
    if (appName && appName === "RDS") {
      //TODO correct applolo gateway to fix
      this.props.getShortcutNavigationOptions();
    }
    const imageString = this.props.profileImage !== "" && this.props.profileImage !== "No Image" ? "data:image/jpg;base64, " + this.props.profileImage : false;
    // : constructImageUrl(this.props.user.email);
    // this.setState({ imageSrc: imageString });
  }

  render() {
    const {
      isSidenavCollapsed,
      location,
      user,
      menus,
      logout,
      dept
    } = this.props;
    let imageString = this.state.imageSrc;
    let userdept;
    if (user && !(0, _lodash.isNil)(user["department"])) {
      userdept = user["department"]["Dept"].slice(1, -1);
      //userdept = userdept.split(" ");
      //userdept.splice(-1, 1);
      //userdept = userdept.join(" ").replace("-", " ");
      userdept = (0, _lodash.replace)(userdept, /([\d*]())/g, ""); //to replace digits
      userdept = (0, _lodash.replace)(userdept, /[()]/g, ""); //to replace paranthesis
      userdept = (0, _lodash.replace)(userdept, "-", " "); //to replace -
      userdept = (0, _lodash.trim)(userdept); //to remove whitespaces leading to trailing
    }
    //  Instead of giving margingLeft one fixed side inside one relative sider used here
    //  else changing baselayout props to add marginLeft cause whole component refresh.
    return /*#__PURE__*/_react.default.createElement(Sider, {
      collapsed: isSidenavCollapsed,
      collapsedWidth: 60
    }, /*#__PURE__*/_react.default.createElement(Sider, {
      trigger: /*#__PURE__*/_react.default.createElement(_CornerstoneButton.default, {
        className: isSidenavCollapsed ? "collapse-trigger" : "trigger",
        icon: isSidenavCollapsed ? "double-right" : "double-left",
        onClick: this.sideNavToggle,
        style: {
          backgroundColor: "rgba(239, 239, 239, 0)",
          color: "#fff"
        }
      }),
      className: "trigger"
      // onMouseEnter={this.sideNavShow}
      // onMouseLeave={this.sideNavHide}
      ,
      collapsible: true,
      collapsedWidth: 60,
      collapsed: isSidenavCollapsed,
      theme: "light",
      className: "baseSider"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "sidebar-overlay-dark"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "profile-wrapper"
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginTop: "5px"
      }
    })), /*#__PURE__*/_react.default.createElement(_Menu.default, {
      defaultSelectedKeys: ["appstore"],
      selectedKeys: [location.pathname],
      defaultOpenKeys: ["appstore"],
      menus: menus,
      shortcutNavigationMenuOptions: this.props.dbMenus,
      user: this.props.user
    }))));
  }
}
exports.default = _default;